module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "About slotlist.info"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" was created by\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(" due to being fed up of having to register in countless ArmA community forums just to participate in ArmA missions. The tools allows for easier creating and management of missions and provides easy and direct access to all users - all that's required is a Steam account, and you should already have that, otherwise you wouldn't be playing ArmA\n    "), _c('i', {
    staticClass: "fa fa-smile-o"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This service is provided to you for free without any guarantees of uptime or availability - we might shut down\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" without any additional warnings at any time. Since it's our goal to provide an easy tool to a broad number of ArmA enthusiats, we aim for the highest availability and longevity possible and thus appreciate any feedback you have for us.\n  ")], 1), _vm._v(" "), _c('h4', [_vm._v("Development")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" is currently solely developed by\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT"
    }
  }, [_vm._v("MorpheusXAUT")]), _vm._v(". The website's frontend and backend source code repositories as well as the current versions deployed can be found below. Please include this information is bug reports as it helps with narrowing down issues.\n    ")], 1), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-1"
  }, [_vm._v("frontend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-frontend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.frontendVersion),
      expression: "frontendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.frontendVersion))])]), _vm._v(" "), _c('dt', {
    staticClass: "col-1"
  }, [_vm._v("backend")]), _vm._v(" "), _c('dd', {
    staticClass: "col-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-backend"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" slotlist-backend")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backendVersion),
      expression: "backendVersion"
    }]
  }, [_vm._v(_vm._s(_vm.backendVersion))])])]), _vm._v("\n    You can also use these repositories and their respective issue trackers to report any bugs you encounter - or use one of the contact methods available, as mentioned below.\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Contact us")]), _vm._v(" "), _c('p', {
    staticClass: "text-justify"
  }, [_vm._v("\n    Should you run into any issues or bugs or have a suggestion for our site, feel free to:\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("open an issue on GitHub")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/MorpheusXAUT/slotlist-frontend/issues"
    }
  }, [_vm._v("issue tracker")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("email us directly")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "mailto:hello@slotlist.info?subject=slotlist.info - Hello!"
    }
  }, [_vm._v("hello@slotlist.info")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("join our Discord server")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://discord.gg/QZ5HpwT"
    }
  }, [_vm._v("Discord")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-3"
  }, [_vm._v("add the developer on Steam")]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-9"
  }, [_c('a', {
    attrs: {
      "href": "https://steamcommunity.com/id/morpheusxaut"
    }
  }, [_vm._v("MorpheusXAUT")])])]), _vm._v("\n    Contact details for legal inquiries can be found on the\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'imprint'
      }
    }
  }, [_vm._v("imprint")]), _vm._v(".\n  "), _c('p'), _vm._v(" "), _c('h4', [_vm._v("Special thanks & credits")]), _vm._v(" "), _c('p', [_vm._v("\n    Last, but not least, there's a few people that I, MorpheusXAUT, would like to thank (in no particular order):\n    ")]), _c('dl', {
    staticClass: "row"
  }, [_c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/Regner"
    }
  }, [_vm._v("Regner")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for helping me start this project, set everything up and not complaining about my question bombardment")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] LeWarz")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for suggesting features and functionality, testing the service and providing general feedback")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Belbo")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feature suggestions and feedback as well as proofreading my partly random translations")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] Sinus")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feedback regarding the structure and design of the site, general testing and filling my database with trash data")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://spezialeinheit-luchs.de"
    }
  }, [_vm._v("[SeL] buur")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for constant feedback and suggestions as well as testing all different kinds of functionality")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "https://task-force-wolf.de"
    }
  }, [_vm._v("[TFW] Isaac")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feedback, suggestions and bug reports")]), _vm._v(" "), _c('dt', {
    staticClass: "col-sm-2"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jaegerzug-achilles.de"
    }
  }, [_vm._v("[JgZg-A] Steff")])]), _vm._v(" "), _c('dd', {
    staticClass: "col-sm-10"
  }, [_vm._v("for feature suggestions and providing an Austrian translation")])]), _vm._v(" "), _c('p')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a42be5b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/About.en.vue
// module id = 556
// module chunks = 0